module.exports = __webpack_public_path__ + "static/2-bb2ef99e5539b260443a22ba0c1d0063.jpg";